export default "__VITE_ASSET__SPSkONRZ__"